//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React from 'react';
// import './style.scss';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Check } from 'src/onboarding/components/ui/check/Check';
import { Option } from 'src/onboarding/components/ui/check/Option';
import { Title } from 'src/onboarding/components/typography/Title/Title';

function Page() {
  const crabDense = useStore((state) => state.crabDense);
  const setCrabDense = useStore((state) => state.setCrabDense);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.crabDense.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={crabDense}
          onChange={(value) => {
            setCrabDense(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'carb-dense',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'Very often'}>{t('onboarding.crabDense.options.veryOften')}</Option>
          <Option value={'Sometimes'}>{t('onboarding.crabDense.options.sometimes')}</Option>
          <Option value={'Rarely'}>{t('onboarding.crabDense.options.rarely')}</Option>
          <Option value={'Not at all'}>{t('onboarding.crabDense.options.notAtAll')}</Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
